export type ByteUnit =
	| 'Bytes'
	| 'KB'
	| 'MB'
	| 'GB'
	| 'TB'
	| 'PB'
	| 'EB'
	| 'ZB'
	| 'YB';

// https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
function formatBytes(
	inBytes: number | string,
	decimals?: number,
	/** The unit to use for the output. If not provided, the unit will be determined by the input size. */
	unit?: ByteUnit,
) {
	const bytes = typeof inBytes === 'string' ? parseFloat(inBytes) : inBytes;
	if (bytes === 0)
		return {
			raw: 0,
			withUnit: '0 Bytes',
		};
	const k = 1024;
	const dm = decimals && decimals <= 0 ? 0 : decimals || 2;
	const sizes: ByteUnit[] = [
		'Bytes',
		'KB',
		'MB',
		'GB',
		'TB',
		'PB',
		'EB',
		'ZB',
		'YB',
	] as const;
	const i = unit
		? sizes.indexOf(unit)
		: Math.max(0, Math.floor(Math.log(bytes) / Math.log(k)));
	const raw = parseFloat((bytes / k ** i).toFixed(dm));
	const returnedUnit = unit || sizes[i];
	return {
		raw,
		withUnit: `${raw} ${returnedUnit}`,
		rounded: Math.round(raw),
		unit: returnedUnit,
	};
}

export default formatBytes;
